import GET_ARTICLES from "../plugins/getArticles";

export function SHINKAIKAN(){

  document.addEventListener('DOMContentLoaded', () => {
    GET_ARTICLES('.shinkaikan-news__list[data-plugin="getArticles"]',{
      makeItem (item) {
        return $(`
        <a href="${item.href}" class="card-link">
          <span class="card-date">${item.date}</span>
          <div class="card-title">${item.title}</div>
          <p class="card-desc">${item.desc}</p>
        </a>
        `)[0];
      }
    })
    .then(articles => {
      if (articles.length === 0) {
        $('.shinkaikan__news-section').hide();
      }
    });  
});
}